import React, { useEffect, useState } from "react";
import { useParams, Link, useHistory } from "react-router-dom";
import ReactDOM from 'react-dom';
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import Loading from "../general/Loading";
import VistaPreviaFactura from "./VistaPreviaFactura";
import VistaPreviaFacturaPDF from "./VistaPreviaFacturaPDF";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Modal, Button } from "react-bootstrap";
import { usuarioTieneFirma, usuarioTieneRegistro } from "../../../resources/Helper";
import "../common/ModalEnviarEmail.css";

function InformacionFactura() {
    const { id } = useParams();
    const history = useHistory();
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [factura, setFactura] = useState(null);
    const [loading, setLoading] = useState(true);
    const [recibosFactura, setRecibosFactura] = useState([]);
    const [pacientes, setPacientes] = useState([]);
    const [respuestaDian, setRespuestaDian] = useState(null);
    const [permisos, setPermisos] = useState([]);
    const [usuarios, setUsuarios] = useState([]); // 🆕 Estado para usuarios

    // ðŸ†• ESTADO PARA ENCABEZADO PERSONALIZADO
    const [encabezadoPersonalizado, setEncabezadoPersonalizado] = useState(null);

    // Modal Registrar Recibo de Caja
    const [showModalRecibo, setShowModalRecibo] = useState(false);
    const [valorRecibo, setValorRecibo] = useState('');
    const [medioPago, setMedioPago] = useState('10');
    const [fechaPago, setFechaPago] = useState(new Date().toISOString().split('T')[0]);
    const [observacionesRecibo, setObservacionesRecibo] = useState('');

    // Modal Éxito Recibo
    const [showModalExitoRecibo, setShowModalExitoRecibo] = useState(false);
    const [reciboGuardado, setReciboGuardado] = useState(null);

    // Modal Completar Información (para Atender Paciente)
    const [showModalCompletarInfo, setShowModalCompletarInfo] = useState(false);

    // Modal Enviar Email
    const [showModalEmail, setShowModalEmail] = useState(false);
    const [emailDestino, setEmailDestino] = useState('');
    const [pacienteFactura, setPacienteFactura] = useState(null);
    const [enviandoEmail, setEnviandoEmail] = useState(false);

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // ðŸ”’ VALIDACIÃ“N DE PERMISOS - Verificar acceso a ver informaciÃ³n de factura
        const tienePermiso = userdata.up && userdata.up.includes('ver_informacion_factura');

        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecuciÃ³n si no tiene permisos
        }

        setHasPermission(true);
        setPermisos(userdata.up || []);

        // âœ… Ya NO necesitas config - el interceptor agrega el token automÃ¡ticamente

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // 🆕 Cargar usuarios del cliente para obtener nombre del facturador
        axios.get('/users-by-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar factura especÃ­fica
        if (id) {
            axios.get(`/factura/${id}?uid=${userdata.user_id}`)
                .then(response => {
                    if (response.status === 200) {
                        setFactura(response.data);
                        // Cargar recibos de la factura
                        cargarRecibos(id, userdata.user_id);
                        // Cargar respuesta DIAN si es factura electrÃ³nica
                        if ([1, 2, 3].includes(response.data.estado)) {
                            cargarRespuestaDian(id);
                        }

                        // ðŸ†• Cargar encabezado personalizado del usuario que creÃ³ la factura
                        if (response.data.users_id) {
                            axios.get(`/encabezado-personalizado?uid=${response.data.users_id}`)
                                .then(encResponse => {
                                    if (encResponse.status === 200 && encResponse.data && encResponse.data.estado === 1) {
                                        setEncabezadoPersonalizado(encResponse.data);
                                        console.log('Encabezado personalizado cargado:', encResponse.data);
                                    }
                                })
                                .catch(error => {
                                    console.log('No hay encabezado personalizado habilitado:', error);
                                    setEncabezadoPersonalizado(null);
                                });
                        }
                    }
                })
                .catch(error => {
                    console.log('Error cargando factura: ' + error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [id]);

    const cargarRecibos = (facturaId, userId) => {
        axios.get(`/recibos-caja/${facturaId}?uid=${userId}`)
            .then(response => {
                if (response.status === 200) {
                    setRecibosFactura(response.data);
                }
            })
            .catch(error => {
                console.log('Error cargando recibos: ' + error);
            });
    };

    const cargarRespuestaDian = (facturaId) => {
        axios.get(`/factura/${facturaId}/respuesta-dian`)
            .then(response => {
                if (response.data.success) {
                    setRespuestaDian(response.data.data);
                }
            })
            .catch(error => {
                console.log('No hay respuesta DIAN para esta factura');
            });
    };

    const getEstadoTexto = (estado) => {
        switch (estado) {
            case 0: return 'Generada';
            case 1: return 'Cobrada';
            case 2: return 'Por Cobrar';
            case 3: return 'Anulada';
            case 4: return 'Cobrada';
            case 5: return 'Por Cobrar';
            case 6: return 'Error DIAN';
            default: return 'Desconocido';
        }
    };

    const getEstadoColor = (estado) => {
        switch (estado) {
            case 0: return 'badge badge-outline-secondary';
            case 1: return 'badge badge-outline-success';
            case 2: return 'badge badge-outline-warning';
            case 3: return 'badge badge-outline-danger';
            case 4: return 'badge badge-outline-success';
            case 5: return 'badge badge-outline-warning';
            case 6: return 'badge badge-outline-danger';
            default: return 'badge badge-outline-secondary';
        }
    };

    const getMedioPagoTexto = (codigo) => {
        const mediosPago = {
            '10': 'Efectivo',
            '42': 'Consignación bancaria',
            '1': 'Instrumento no definido',
            '20': 'Cheque',
            '30': 'Transferencia Crédito',
            '31': 'Transferencia Débito',
            '45': 'Transferencia Crédito Bancario',
            '47': 'Transferencia Débito Bancaria',
            '48': 'Tarjeta Crédito',
            '49': 'Tarjeta Débito',
            'ZZZ': 'Acuerdo mutuo'
        };
        return mediosPago[codigo] || codigo;
    };

    /** Fechas solo-día (YYYY-MM-DD del backend): parsear sin UTC para no mostrar el día anterior. */
    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const s = String(fecha).trim();
        const parte = s.includes('T') ? s.split('T')[0] : s.split(/\s+/)[0];
        const match = parte.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (match) {
            return `${match[3]}/${match[2]}/${match[1].slice(-2)}`;
        }
        const date = new Date(fecha);
        if (Number.isNaN(date.getTime())) return '';
        const dia = String(date.getDate()).padStart(2, '0');
        const mes = String(date.getMonth() + 1).padStart(2, '0');
        const anio = String(date.getFullYear()).slice(-2);
        return `${dia}/${mes}/${anio}`;
    };

    const construirDireccionCompleta = (paciente) => {
        if (!paciente) return '';
        const partes = [];
        if (paciente.direccion) partes.push(paciente.direccion);
        if (paciente.zona) partes.push(paciente.zona);
        if (paciente.nombre_ciudad_residencia) partes.push(paciente.nombre_ciudad_residencia);
        if (paciente.nombre_departamento_residencia) partes.push(paciente.nombre_departamento_residencia);
        if (paciente.nombre_pais_residencia) partes.push(paciente.nombre_pais_residencia);
        return partes.join(', ') || paciente.direccion || '';
    };

    const obtenerNit = (pacienteRef) => {
        const p = pacienteRef || pacientes.find((item) => String(item.id) === String(factura?.paciente_id));
        if (!p) return '';
        return p.numero_documento || p.numeroDocumento || '';
    };

    const resolverPacienteFactura = async (pacienteId) => {
        if (!pacienteId) return null;
        let paciente = pacientes.find((item) => String(item.id) === String(pacienteId));
        if (!paciente?.numero_documento) {
            try {
                const userdata = JSON.parse(localStorage.getItem('userdata') || '{}');
                const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteId}`);
                if (response.data?.[0]) {
                    paciente = response.data[0];
                }
            } catch (error) {
                console.log('Error cargando paciente completo:', error);
            }
        }
        return paciente || null;
    };

    useEffect(() => {
        if (!factura?.paciente_id) {
            setPacienteFactura(null);
            return undefined;
        }
        let cancelled = false;
        (async () => {
            const paciente = await resolverPacienteFactura(factura.paciente_id);
            if (!cancelled) {
                setPacienteFactura(paciente);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [factura?.paciente_id, pacientes]);

    const getNombrePaciente = (pacienteId) => {
        const paciente = pacientes.find(p => p.id === pacienteId);
        if (paciente) {
            return `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        }
        return 'N/A';
    };

    // 🆕 Función para obtener nombre del usuario (facturador)
    const getNombreUsuario = (usuarioId) => {
        const usuario = usuarios.find(u => u.id == usuarioId);
        return usuario ? usuario.name : 'N/A';
    };

    const anularRecibo = async (reciboId) => {
        if (!window.confirm('Â¿EstÃ¡ seguro de anular este recibo?')) {
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // âœ… Ya NO necesitas config - el interceptor agrega el token automÃ¡ticamente

        const estadoDestino = factura.estado === 5 ? 5 : 2;

        try {
            const response = await axios.put(`/recibo-caja/${reciboId}/anular?uid=${userdata.user_id}`,
                { estado_factura_destino: estadoDestino }
            );
            if (response.status === 200) {
                alert('Recibo anulado exitosamente');
                cargarRecibos(id, userdata.user_id);
                // Recargar factura para actualizar estado
                axios.get(`/factura/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setFactura(response.data);
                        }
                    });
            }
        } catch (error) {
            alert('Error al anular el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const abrirModalRecibo = () => {
        const valorPendiente = factura?.valor_pendiente || factura?.valor_total || 0;
        setValorRecibo(valorPendiente);
        setMedioPago('10');
        setFechaPago(new Date().toISOString().split('T')[0]);
        setObservacionesRecibo('');
        setShowModalRecibo(true);
    };

    const guardarRecibo = async () => {
        const valorPendiente = factura?.valor_pendiente || factura?.valor_total;

        if (!valorRecibo || parseFloat(valorRecibo) <= 0) {
            alert('Ingrese un valor vÃ¡lido');
            return;
        }

        if (parseFloat(valorRecibo) > parseFloat(valorPendiente)) {
            alert(`El valor no puede ser mayor al saldo pendiente: $${Math.round(parseFloat(valorPendiente)).toLocaleString('es-CO')}`);
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // âœ… Ya NO necesitas config - el interceptor agrega el token automÃ¡ticamente

        const reciboData = {
            factura_id: factura.id,
            valor_recibido: parseFloat(valorRecibo),
            medio_pago: medioPago,
            fecha_pago: fechaPago,
            observaciones: observacionesRecibo
        };

        try {
            const response = await axios.post('/recibo-caja', reciboData);
            if (response.status === 200 || response.status === 201) {
                setShowModalRecibo(false);
                setReciboGuardado(response.data);
                setShowModalExitoRecibo(true);
                // Recargar recibos y factura
                cargarRecibos(id, userdata.user_id);
                axios.get(`/factura/${id}?uid=${userdata.user_id}`)
                    .then(response => {
                        if (response.status === 200) {
                            setFactura(response.data);
                        }
                    });
            }
        } catch (error) {
            alert('Error al registrar el recibo: ' + (error.response?.data?.message || error.message));
        }
    };

    const generarAsientoContable = () => {
        if (!factura) return [];

        const valorTotal = parseFloat(factura.valor_total || 0);
        const asiento = [];

        // Obtener recibos activos
        const recibosActivos = recibosFactura.filter(r => r.estado !== 0);
        const totalRecibos = recibosActivos.reduce((sum, r) => sum + parseFloat(r.valor_pago), 0);

        // LÃ“GICA CORREGIDA: Usar el campo tipo_pago de la factura
        // Si tipo_pago = "contado" -> Venta de contado
        // Si tipo_pago = "credito" -> Venta a crÃ©dito
        const esVentaContado = factura.tipo_pago === 'contado';

        if (esVentaContado) {
            // VENTA DE CONTADO - Asiento único
            // Determinar cuenta de débito según forma_pago de la factura
            const medioPago = factura.forma_pago;

            let cuentaDebito = '1110'; // Por defecto (Bancos)
            let conceptoDebito = 'Bancos';

            if (medioPago === '10') {
                cuentaDebito = '1105';
                conceptoDebito = 'Caja';
            }

            // Débito - Caja o Bancos
            asiento.push({
                tipo: 'factura',
                tercero: client?.nombre || '',
                codigo: cuentaDebito,
                cuentaContable: conceptoDebito,
                centroCosto: '',
                debito: valorTotal,
                credito: 0,
                concepto: `Servicios médicos - Factura ${factura.numero_factura}`
            });

            // Crédito - Ventas
            asiento.push({
                tipo: 'factura',
                tercero: client?.nombre || '',
                codigo: '4165',
                cuentaContable: 'Ventas',
                centroCosto: '',
                debito: 0,
                credito: valorTotal,
                concepto: `Servicios médicos - Factura ${factura.numero_factura}`
            });

        } else {
            // VENTA A CRÉDITO - Asiento de la factura + asientos de cada recibo

            // 1. ASIENTO DE LA FACTURA (Venta a crédito)
            asiento.push({
                tipo: 'factura',
                tercero: client?.nombre || '',
                codigo: '1305',
                cuentaContable: 'Cuentas por cobrar',
                centroCosto: '',
                debito: valorTotal,
                credito: 0,
                concepto: `Servicios médicos - Factura ${factura.numero_factura}`
            });

            asiento.push({
                tipo: 'factura',
                tercero: client?.nombre || '',
                codigo: '4165',
                cuentaContable: 'Ventas',
                centroCosto: '',
                debito: 0,
                credito: valorTotal,
                concepto: `Servicios médicos - Factura ${factura.numero_factura}`
            });

            // 2. ASIENTOS DE LOS RECIBOS DE CAJA (Reducción del saldo)
            recibosActivos.forEach(recibo => {
                const valorRecibo = parseFloat(recibo.valor_pago);
                const medioPago = recibo.forma_pago;

                let cuentaDebito = '1110'; // Por defecto
                let conceptoDebito = 'Bancos';

                if (medioPago === '10') {
                    cuentaDebito = '1105';
                    conceptoDebito = 'Caja';
                }

                // Débito - Caja o Bancos (por el pago recibido)
                asiento.push({
                    tipo: 'recibo',
                    tercero: client?.nombre || '',
                    codigo: cuentaDebito,
                    cuentaContable: conceptoDebito,
                    centroCosto: '',
                    debito: valorRecibo,
                    credito: 0,
                    concepto: `Pago recibo ${recibo.numero_recibo} - Factura ${factura.numero_factura}`
                });

                // Crédito - Cuentas por cobrar (reducción del saldo)
                asiento.push({
                    tipo: 'recibo',
                    tercero: client?.nombre || '',
                    codigo: '1305',
                    cuentaContable: 'Cuentas por cobrar',
                    centroCosto: '',
                    debito: 0,
                    credito: valorRecibo,
                    concepto: `Pago recibo ${recibo.numero_recibo} - Factura ${factura.numero_factura}`
                });
            });
        }

        return asiento;
    };

    const imprimirAsientoContable = () => {
        const asiento = generarAsientoContable();
        const fechaHoy = new Date().toLocaleDateString('es-CO');
        const totalDebito = asiento.reduce((sum, item) => sum + item.debito, 0);
        const totalCredito = asiento.reduce((sum, item) => sum + item.credito, 0);

        const contenidoAsiento = `
            <div style="padding: 20px; font-family: Arial, sans-serif;">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="text-align: center; margin-bottom: 30px;">
                    <h2 style="margin: 0; color: #333;">ASIENTO CONTABLE</h2>
                    <p style="margin: 5px 0; color: #666;">Factura N° ${factura?.numero_factura}</p>
                    <p style="margin: 5px 0; color: #666;">Fecha: ${fechaHoy}</p>
                </div>

                <div style="background: #e3f2fd; padding: 15px; border-radius: 5px; margin-bottom: 20px;">
                    <p style="margin: 0; color: #1976d2; font-size: 14px;">
                        <i class="fas fa-info-circle"></i> 
                        Visualiza el movimiento contable de este comprobante. Incluye asientos de factura y recibos de caja.
                    </p>
                </div>

                <table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
                    <thead>
                        <tr style="background-color: #f5f5f5;">
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: left; font-weight: bold;">Tercero</th>
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: left; font-weight: bold;">Código</th>
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: left; font-weight: bold;">Cuenta contable</th>
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: left; font-weight: bold;">Concepto</th>
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: right; font-weight: bold;">Débito</th>
                            <th style="border: 1px solid #ddd; padding: 12px; text-align: right; font-weight: bold;">Crédito</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${asiento.map(item => `
                            <tr style="${item.tipo === 'recibo' ? 'background-color: #f8f9fa;' : ''}">
                                <td style="border: 1px solid #ddd; padding: 10px;">${item.tercero}</td>
                                <td style="border: 1px solid #ddd; padding: 10px; text-align: center; font-weight: bold;">${item.codigo}</td>
                                <td style="border: 1px solid #ddd; padding: 10px;">${item.cuentaContable}</td>
                                <td style="border: 1px solid #ddd; padding: 10px; font-size: 11px;">${item.concepto}</td>
                                <td style="border: 1px solid #ddd; padding: 10px; text-align: right; font-weight: bold;">
                                    ${item.debito > 0 ? '$' + Math.round(item.debito).toLocaleString('es-CO') : ''}
                                </td>
                                <td style="border: 1px solid #ddd; padding: 10px; text-align: right; font-weight: bold;">
                                    ${item.credito > 0 ? '$' + Math.round(item.credito).toLocaleString('es-CO') : ''}
                                </td>
                            </tr>
                        `).join('')}
                    </tbody>
                    <tfoot>
                        <tr style="background-color: #f0f8ff; font-weight: bold;">
                            <td colspan="4" style="border: 1px solid #ddd; padding: 12px; text-align: right;">TOTAL</td>
                            <td style="border: 1px solid #ddd; padding: 12px; text-align: right; color: #2e7d32;">
                                $${Math.round(totalDebito).toLocaleString('es-CO')}
                            </td>
                            <td style="border: 1px solid #ddd; padding: 12px; text-align: right; color: #2e7d32;">
                                $${Math.round(totalCredito).toLocaleString('es-CO')}
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <div style="margin-top: 30px; font-size: 12px; color: #666;">
                    <p><strong>Notas:</strong></p>
                    <ul style="margin: 10px 0; padding-left: 20px;">
                        <li>1105: Caja (para pagos en efectivo)</li>
                        <li>1110: Bancos (para otros medios de pago)</li>
                        <li>1305: Cuentas por cobrar (ventas a crédito)</li>
                        <li>4165: Ingresos por servicios médicos</li>
                        <li>Las filas sombreadas corresponden a asientos de recibos de caja</li>
                    </ul>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=900,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Asiento Contable - Factura N° ${factura?.numero_factura}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoAsiento}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const vistaPreviaRecibo = async (recibo) => {
        let paciente = pacientes.find(p => p.id === factura?.paciente_id);

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        // âœ… Ya NO necesitas config - el interceptor agrega el token automÃ¡ticamente
        try {
            const response = await axios.get(`/paciente?uid=${userdata.user_id}&id=${factura?.paciente_id}`);
            if (response.data && response.data.length > 0) {
                paciente = response.data[0];
            }
        } catch (error) {
            console.log('Error cargando paciente completo:', error);
        }

        const nombrePaciente = paciente ? `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim() : getNombrePaciente(factura?.paciente_id);

        // 🆕 Generar encabezado personalizado
        const encabezadoHTML = generarEncabezadoHTML();

        // 🆕 Obtener nombre del facturador (usuario que creó la factura)
        const nombreFacturador = factura?.users_id ? getNombreUsuario(factura.users_id) : 'N/A';

        // 🆕 BANNER: RECIBO DE CAJA
        const bannerHTML = `
            <div style="margin-bottom: 10px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 13px; border-radius: 3px; text-align: center;">
                    RECIBO DE CAJA - FACTURA N° ${factura?.numero_factura || ''}
                </div>
            </div>
        `;

        // 🆕 Datos del recibo en tabla
        const datosReciboHTML = `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px; font-size: 11px;">
                <tbody>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">RECIBO #</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${recibo.numero_recibo}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FECHA PAGO</td>
                        <td style="background-color: #ffffff; width: 18%; padding: 6px; border: 1px solid #dee2e6;">${formatearFecha(recibo.fecha_pago)}</td>
                        <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FORMA DE PAGO</td>
                        <td style="background-color: #ffffff; width: 19%; padding: 6px; border: 1px solid #dee2e6;">${getMedioPagoTexto(recibo.forma_pago)}</td>
                    </tr>
                    <tr>
                        <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; border: 1px solid #dee2e6;">FACTURADOR</td>
                        <td colspan="5" style="background-color: #ffffff; padding: 6px; border: 1px solid #dee2e6;">${nombreFacturador}</td>
                    </tr>
                </tbody>
            </table>
        `;

        const contenidoRecibo = `
            <div style="container-fluid p-4">
                <div class="no-print" style="margin-bottom: 20px;">
                    <button onclick="window.print()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; margin-right: 10px;">Imprimir</button>
                    <button onclick="window.close()" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer;">Cerrar</button>
                </div>

                <div style="padding: 15px; margin-bottom: 20px;">
                    ${encabezadoHTML}
                    
                    ${bannerHTML}
                    
                    ${datosReciboHTML}

                    <table style="width: 100%; border-collapse: collapse; background-color: #f8f9fa; font-size: 12px; margin-bottom: 20px;">
                        <tbody>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">RAZÓN SOCIAL</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${nombrePaciente}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; width: 15%; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">NIT</td>
                                <td style="background-color: #ffffff; width: 35%; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${obtenerNit(paciente)}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">TELÉFONO</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.telefono || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">CELULAR</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.celular || '') : ''}</td>
                            </tr>
                            <tr>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">EMAIL</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${paciente ? (paciente.email || '') : ''}</td>
                                <td style="background-color: #e9ecef; font-weight: bold; vertical-align: middle; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">DIRECCIÓN</td>
                                <td style="background-color: #ffffff; padding: 6px; font-size: 11px; border: 1px solid #dee2e6;">${construirDireccionCompleta(paciente)}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                        <thead>
                            <tr style="background-color: #e9ecef;">
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: left; font-size: 12px;">Concepto</th>
                                <th style="border: 1px solid #dee2e6; padding: 8px; text-align: right; font-size: 12px;">Valor</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="border: 1px solid #dee2e6; padding: 8px; background-color: #ffffff; font-size: 12px;">Abono a Factura N° ${factura?.numero_factura || ''}</td>
                                <td style="border: 1px solid #dee2e6; padding: 8px; text-align: right; background-color: #ffffff; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div style="display: flex; justify-content: flex-end; padding-right: 15px;">
                        <table style="width: auto; border-collapse: collapse;">
                            <tbody>
                                <tr>
                                    <td style="text-align: right; padding: 8px 16px 8px 8px; border: none; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif; white-space: nowrap;">Total:</td>
                                    <td style="text-align: right; padding: 8px; border: none; min-width: 130px; font-size: 12px; font-weight: 600; font-family: Arial, sans-serif;">$${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    ${recibo.observaciones ? `
                    <div style="margin-top: 20px;">
                        <h6 style="font-size: 14px; font-weight: bold;">Observaciones:</h6>
                        <p style="font-size: 12px;">${recibo.observaciones}</p>
                    </div>
                    ` : ''}

                    <div style="margin-top: 40px; text-align: center; border-top: 1px solid #ddd; padding-top: 20px;">
                        <p style="color: #666; margin-bottom: 30px; font-size: 12px;">Recibí conforme el valor arriba mencionado</p>
                        <div style="margin-top: 50px;">
                            <div style="border-top: 1px solid #333; width: 200px; margin: 0 auto;"></div>
                            <p style="margin-top: 5px; color: #666; font-size: 12px;">Firma del Paciente</p>
                        </div>
                    </div>
                </div>

                <style>
                    @media print {
                        .no-print {
                            display: none !important;
                        }
                        body {
                            margin: 0;
                            padding: 0;
                        }
                    }
                </style>
            </div>
        `;

        const ventana = window.open('', '_blank', 'width=800,height=700,scrollbars=yes,resizable=yes');
        ventana.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Recibo de Caja N° ${recibo.numero_recibo}</title>
                <style>
                    body { font-family: Arial, sans-serif; margin: 20px; background: #fff; }
                    @media print { 
                        body { margin: 0; padding: 0; }
                        .no-print { display: none !important; }
                    }
                </style>
            </head>
            <body>
                ${contenidoRecibo}
            </body>
            </html>
        `);
        ventana.document.close();
    };

    const handleCloseModalInfo = () => setShowModalCompletarInfo(false);
    const handleCompletarInfo = () => history.push('/configuracion');

    // ðŸ†• FunciÃ³n para generar encabezado personalizado HTML
    const generarEncabezadoHTML = () => {
        if (!encabezadoPersonalizado) {
            return '';
        }

        // FunciÃ³n auxiliar para limpiar HTML y evitar saltos de lÃ­nea innecesarios
        const limpiarHTML = (html) => {
            if (!html) return '';
            // Reemplazar <p> tags con divs para un control mÃ¡s preciso
            return html
                .replace(/<p>/gi, '<div style="margin: 0; padding: 0; line-height: 1.1;">')
                .replace(/<\/p>/gi, '</div>')
                .replace(/<br\s*\/?>/gi, '<br style="line-height: 1.1;" />');
        };

        // USAR TABLA EN LUGAR DE FLEXBOX PARA MEJOR COMPATIBILIDAD CON PDF
        // FONDO BLANCO Y SIN BORDES
        return `
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 10px; background-color: #ffffff;">
                <tr>
                    <!-- Columna Izquierda (30%) -->
                    <td style="width: 30%; padding: 2px; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.izquierda)}
                    </td>
                    
                    <!-- Columna Centro (40%) -->
                    <td style="width: 40%; padding: 2px; text-align: center; font-size: 11px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.centro)}
                    </td>
                    
                    <!-- Columna Derecha (30%) -->
                    <td style="width: 30%; padding: 2px; text-align: right; font-size: 10px; line-height: 1.1; vertical-align: top; word-wrap: break-word;">
                        ${limpiarHTML(encabezadoPersonalizado.derecha)}
                    </td>
                </tr>
            </table>
        `;
    };

    const obtenerOpcionesHtml2PdfFactura = (numeroFactura, { ligero = false } = {}) => ({
        margin: 10,
        filename: `factura-${numeroFactura}.pdf`,
        image: { type: 'jpeg', quality: ligero ? 0.88 : 0.95 },
        html2canvas: {
            scale: ligero ? 1.75 : 2,
            useCORS: true,
            logging: false,
            letterRendering: true,
            backgroundColor: '#ffffff'
        },
        jsPDF: {
            unit: 'mm',
            format: 'letter',
            orientation: 'portrait',
            compress: true
        },
        pagebreak: {
            mode: ['avoid-all', 'css', 'legacy']
        }
    });

    /** Genera el PDF solo desde VistaPreviaFacturaPDF en un contenedor aislado (evita duplicar #factura-pdf-editable de la página). */
    const generarElementoPdfFacturaAislado = async () => {
        const pacientePdf = await resolverPacienteFactura(factura.paciente_id);
        const facturador = usuarios.find((u) => String(u.id) === String(factura.users_id));
        const contenedorId = `factura-pdf-export-${Date.now()}`;

        const contenedorTemporal = document.createElement('div');
        contenedorTemporal.setAttribute('data-factura-pdf-export', '1');
        contenedorTemporal.style.position = 'fixed';
        contenedorTemporal.style.left = '-10000px';
        contenedorTemporal.style.top = '0';
        contenedorTemporal.style.width = '800px';
        contenedorTemporal.style.background = '#ffffff';
        contenedorTemporal.style.zIndex = '-1';
        contenedorTemporal.style.overflow = 'hidden';
        document.body.appendChild(contenedorTemporal);

        ReactDOM.render(
            <VistaPreviaFacturaPDF
                factura={factura}
                client={client}
                paciente={pacientePdf}
                encabezadoPersonalizado={encabezadoPersonalizado}
                respuestaDian={respuestaDian}
                facturador={facturador}
                contenedorId={contenedorId}
            />,
            contenedorTemporal
        );

        await new Promise((resolve) => setTimeout(resolve, 500));

        const element = contenedorTemporal.querySelector(`#${CSS.escape(contenedorId)}`);
        if (!element) {
            ReactDOM.unmountComponentAtNode(contenedorTemporal);
            document.body.removeChild(contenedorTemporal);
            throw new Error('No se pudo generar la vista previa del PDF');
        }

        const cleanup = () => {
            if (contenedorTemporal.parentNode) {
                ReactDOM.unmountComponentAtNode(contenedorTemporal);
                document.body.removeChild(contenedorTemporal);
            }
        };

        return { element, cleanup, pacientePdf, facturador };
    };

    const generarBlobPdfFactura = async ({ ligero = false } = {}) => {
        const { element, cleanup } = await generarElementoPdfFacturaAislado();
        try {
            const html2pdf = await import('html2pdf-fix-jspdf');
            const opt = obtenerOpcionesHtml2PdfFactura(factura.numero_factura, { ligero });
            return await html2pdf.default().from(element).set(opt).outputPdf('blob');
        } finally {
            cleanup();
        }
    };

    // Función para generar PDF editable con CUFE copiable
    const generarPDFEditable = async () => {
        try {
            const { element, cleanup } = await generarElementoPdfFacturaAislado();
            try {
                const html2pdf = await import('html2pdf-fix-jspdf');
                const opt = obtenerOpcionesHtml2PdfFactura(factura.numero_factura);
                opt.filename = `factura-${factura.numero_factura}-editable.pdf`;
                await html2pdf.default().from(element).set(opt).save();
            } finally {
                cleanup();
            }
        } catch (error) {
            console.error('Error generando PDF editable:', error);
            alert('Error al generar el PDF. Por favor, intente nuevamente.');
        }
    };

    // Función para imprimir PDF editable con CUFE copiable
    const imprimirPDFEditable = async () => {
        try {
            const pdfBlob = await generarBlobPdfFactura();
            const url = URL.createObjectURL(pdfBlob);

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);

            iframe.onload = () => {
                setTimeout(() => {
                    iframe.contentWindow.print();
                }, 500);

                setTimeout(() => {
                    if (document.body.contains(iframe)) {
                        document.body.removeChild(iframe);
                        URL.revokeObjectURL(url);
                    }
                }, 60000);
            };
        } catch (error) {
            console.error('Error imprimiendo PDF editable:', error);
            alert('Error al imprimir. Por favor, intente nuevamente.');
        }
    };

    // Función para abrir modal de email
    const abrirModalEmail = () => {
        const paciente = pacienteFactura || pacientes.find(
            (p) => String(p.id) === String(factura?.paciente_id)
        );
        const emailPaciente = paciente?.email || '';
        setEmailDestino(emailPaciente);
        setShowModalEmail(true);
    };

    const enviarFacturaPorEmail = async () => {
        const email = (emailDestino || '').trim();
        if (!email) {
            alert('Por favor ingrese un correo electrónico válido.');
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Por favor ingrese un correo electrónico válido.');
            return;
        }

        const nombreArchivo = `factura-${factura.numero_factura}.pdf`;
        const facturador = usuarios.find((u) => String(u.id) === String(factura.users_id));

        try {
            setEnviandoEmail(true);
            setShowModalEmail(false);

            const pdfBlob = await generarBlobPdfFactura({ ligero: true });

            const maxBytesEmail = 12 * 1024 * 1024;
            if (pdfBlob.size > maxBytesEmail) {
                throw new Error(
                    `El PDF (${(pdfBlob.size / (1024 * 1024)).toFixed(1)} MB) es demasiado grande para enviar por correo. Use Guardar PDF y envíelo manualmente.`
                );
            }

            const base64data = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const result = reader.result;
                    if (!result || typeof result !== 'string') {
                        reject(new Error('No se pudo leer el PDF generado'));
                        return;
                    }
                    resolve(result.split(',')[1]);
                };
                reader.onerror = () => reject(new Error('Error al convertir el PDF'));
                reader.readAsDataURL(pdfBlob);
            });

            await axios.post('/enviar-factura-email', {
                factura_id: factura.id,
                email_destino: email,
                pdf_base64: base64data,
                nombre_archivo: nombreArchivo,
                titulo_documento: `la factura N° ${factura.numero_factura}`,
                nombre_profesional: facturador?.name || ''
            });

            alert(`Factura enviada exitosamente a ${email}`);
        } catch (error) {
            const detalle = error.response?.data;
            console.error('Error enviando factura por email:', detalle || error);
            const mensaje =
                detalle?.message ||
                detalle?.error ||
                (detalle ? JSON.stringify(detalle) : null) ||
                error.message ||
                'Error desconocido';
            alert('Error al enviar la factura por email: ' + mensaje);
        } finally {
            setEnviandoEmail(false);
        }
    };

    // ðŸ”’ PROTECCIÃ“N DE RUTA - Si no tiene permisos, mostrar pÃ¡gina de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || loading) {
        return <Loading />;
    }

    return (
        <div className="hold-transition">
            <style>{`
                .badge-lg {
                    font-size: 0.85em;
                    padding: 0.5em 0.75em;
                }
                .badge-outline-secondary {
                    color: #6c757d;
                    border: 1px solid #6c757d;
                    background-color: transparent;
                }
                .badge-outline-success {
                    color: #28a745;
                    border: 1px solid #28a745;
                    background-color: transparent;
                }
                .badge-outline-warning {
                    color: #ffc107;
                    border: 1px solid #ffc107;
                    background-color: transparent;
                }
                .badge-outline-danger {
                    color: #dc3545;
                    border: 1px solid #dc3545;
                    background-color: transparent;
                }
                .badge-outline-info {
                    color: #17a2b8;
                    border: 1px solid #17a2b8;
                    background-color: transparent;
                }
                .card-info.card-outline {
                    border-top: 3px solid #17a2b8;
                }
                .card-success.card-outline {
                    border-top: 3px solid #28a745;
                }
                .card-warning.card-outline {
                    border-top: 3px solid #ff9800;
                }
                .table th {
                    background-color: #282828;
                    color: #f6fcfd;
                    border-top: none;
                    font-weight: 600;
                    font-size: 0.9rem;
                }
                .table td {
                    vertical-align: middle;
                    font-size: 0.9rem;
                }
                .table tbody tr:hover {
                    background-color: #f6fcfd;
                    transition: all 0.2s ease;
                }
                
                /* Estilos para impresión */
                @media print {
                    /* Forzar impresión de colores de fondo */
                    * {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                        color-adjust: exact !important;
                    }
                    
                    /* Ocultar elementos que no deben imprimirse */
                    .no-print,
                    header,
                    aside,
                    footer,
                    .content-header,
                    .main-sidebar,
                    .navbar {
                        display: none !important;
                    }
                    
                    /* Ajustar el contenedor principal */
                    .content-wrapper {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                    
                    /* Ajustar el contenido de la factura */
                    #vista-previa-factura-container {
                        border: none !important;
                        box-shadow: none !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        page-break-after: avoid !important;
                    }
                    
                    /* Ocultar el header de la card de vista previa */
                    #vista-previa-factura-container .card-header {
                        display: none !important;
                    }
                    
                    #vista-previa-factura-content {
                        padding: 10mm !important;
                    }
                    
                    /* Asegurar que las tablas mantengan sus estilos */
                    .table-bordered {
                        border: 1px solid #dee2e6 !important;
                    }
                    
                    .table-bordered td,
                    .table-bordered th {
                        border: 1px solid #dee2e6 !important;
                    }
                    
                    /* Mantener colores de fondo en celdas */
                    td[style*="background-color"],
                    th[style*="background-color"] {
                        -webkit-print-color-adjust: exact !important;
                        print-color-adjust: exact !important;
                    }
                    
                    /* Ajustar márgenes de página */
                    @page {
                        margin: 5mm;
                        size: landscape;
                    }
                    
                    body {
                        margin: 0 !important;
                        padding: 0 !important;
                    }
                }
            `}</style>
            <Header client={client} />
            <Aside client={client} activelink="billing" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2 align-items-center">
                            <div className="col-sm-6">
                                <h1 className="m-0">
                                    Información de Factura N° {factura?.numero_factura}
                                </h1>
                            </div>
                            <div className="col-sm-6">
                                {/* Botones de Navegación Rápida - Orden: Registrar Abono, Atender Paciente, Cartera, Volver */}
                                <div className="d-flex justify-content-end flex-wrap" style={{ gap: '8px' }}>
                                    {/* Botón Registrar Abono - Solo si la factura está Por Cobrar (estado 2 o 5) */}
                                    {(factura?.estado === 2 || factura?.estado === 5) && (
                                        <button
                                            className="btn btn-primary"
                                            onClick={abrirModalRecibo}
                                            title="Registrar Abono"
                                            style={{ 
                                                minWidth: '140px',
                                                fontWeight: '500',
                                                boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
                                            }}
                                        >
                                            <i className="fas fa-money-bill-wave mr-2"></i>
                                            Registrar Abono
                                        </button>
                                    )}

                                    {/* Botón Atender Paciente - Solo si tiene permiso */}
                                    {permisos.includes('atenderPacientes') && factura?.paciente_id && (
                                        <>
                                            {usuarioTieneFirma() && usuarioTieneRegistro() ? (
                                                <Link
                                                    to={`/atender-paciente?id=${factura.paciente_id}`}
                                                    className="btn btn-success"
                                                    title="Atender paciente"
                                                    style={{ 
                                                        minWidth: '110px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 2px 4px rgba(40,167,69,0.2)'
                                                    }}
                                                >
                                                    <i className="fas fa-user-md mr-2"></i>
                                                    Atender
                                                </Link>
                                            ) : (
                                                <button
                                                    onClick={() => setShowModalCompletarInfo(true)}
                                                    className="btn btn-success"
                                                    title="Atender paciente"
                                                    style={{ 
                                                        minWidth: '110px',
                                                        fontWeight: '500',
                                                        boxShadow: '0 2px 4px rgba(40,167,69,0.2)'
                                                    }}
                                                >
                                                    <i className="fas fa-user-md mr-2"></i>
                                                    Atender
                                                </button>
                                            )}
                                        </>
                                    )}

                                    {/* Botón Cartera */}
                                    {factura?.paciente_id && (
                                        <Link
                                            to={`/estado-cuenta-paciente?id=${factura.paciente_id}`}
                                            className="btn btn-info"
                                            title="Ver estado de cuenta del paciente"
                                            style={{ 
                                                minWidth: '100px',
                                                fontWeight: '500',
                                                boxShadow: '0 2px 4px rgba(23,162,184,0.2)'
                                            }}
                                        >
                                            <i className="fas fa-dollar-sign mr-2"></i>
                                            Cartera
                                        </Link>
                                    )}

                                    {/* Botón Volver al Listado */}
                                    <Link
                                        to="/listado-facturas"
                                        className="btn btn-secondary"
                                        title="Volver al listado de facturas"
                                        style={{ 
                                            minWidth: '100px',
                                            fontWeight: '500',
                                            boxShadow: '0 2px 4px rgba(108,117,125,0.2)'
                                        }}
                                    >
                                        <i className="fas fa-arrow-left mr-2"></i>
                                        Volver
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Indicador de Estado */}
                        <div className="card card-info card-outline no-print" id="estado-factura-section">
                            <div className="card-body py-2">
                                <div className="row align-items-center mb-2">
                                    <div className="col-md-2 col-sm-4">
                                        <small className="text-muted d-block mb-1">Tipo de Factura:</small>
                                        <span className={`badge ${factura?.tipo_factura === 'no_electronica' || [4, 5].includes(factura?.estado)
                                                ? 'badge-outline-secondary'
                                                : 'badge-outline-info'
                                            }`} style={{
                                                borderColor: factura?.tipo_factura === 'no_electronica' || [4, 5].includes(factura?.estado) ? '#6c757d' : '#17a2b8',
                                                color: factura?.tipo_factura === 'no_electronica' || [4, 5].includes(factura?.estado) ? '#6c757d' : '#17a2b8'
                                            }}>
                                            <i className={`fas ${factura?.tipo_factura === 'no_electronica' || [4, 5].includes(factura?.estado)
                                                    ? 'fa-file-alt'
                                                    : 'fa-bolt'
                                                } mr-1`}></i>
                                            {
                                                factura?.tipo_factura === 'no_electronica' || [4, 5].includes(factura?.estado)
                                                    ? 'No Electrónica'
                                                    : 'Electrónica'
                                            }
                                        </span>
                                    </div>
                                    <div className="col-md-2 col-sm-4">
                                        <small className="text-muted d-block mb-1">Estado Factura:</small>
                                        <span className={`${getEstadoColor(factura?.estado)} badge`}>
                                            {getEstadoTexto(factura?.estado)}
                                        </span>
                                    </div>
                                    <div className="col-md-2 col-sm-4">
                                        <small className="text-muted d-block mb-1">Estado DIAN:</small>
                                        <span className={`badge ${[1, 2, 3].includes(factura?.estado) ? 'badge-outline-success' : [4, 5].includes(factura?.estado) ? 'badge-outline-secondary' : 'badge-outline-secondary'}`}>
                                            {[1, 2, 3].includes(factura?.estado) ? 'ENVIADO' : [4, 5].includes(factura?.estado) ? 'NO APLICA' : 'NO ENVIADO'}
                                        </span>
                                    </div>
                                    <div className="col-md-2 col-sm-4">
                                        <small className="text-muted d-block mb-1">Valor Total:</small>
                                        <span className="font-weight-bold">
                                            ${Math.round(parseFloat(factura?.valor_total || 0)).toLocaleString('es-CO')}
                                        </span>
                                    </div>
                                    {(factura?.estado === 2 || factura?.estado === 5) && (
                                        <div className="col-md-4 col-sm-8">
                                            <small className="text-muted d-block mb-1">Saldo Pendiente:</small>
                                            <span className="badge badge-outline-danger" style={{ borderColor: '#dc3545', color: '#dc3545' }}>
                                                <i className="fas fa-exclamation-triangle mr-1"></i>
                                                ${Math.round(parseFloat(factura?.valor_pendiente || factura?.valor_total || 0)).toLocaleString('es-CO')}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                {/* CUFE y Documentos DIAN */}
                                {respuestaDian && (factura?.tipo_factura === 'electronica' || [1, 2, 3].includes(factura?.estado)) && (
                                    <div className="row align-items-center mt-3 pt-3" style={{ borderTop: '1px solid #dee2e6' }}>
                                        <div className="col-md-12">
                                            <small className="text-muted d-block mb-2"><strong>CUFE (Código Único de Factura Electrónica):</strong></small>
                                            <div className="input-group mb-2">
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    value={respuestaDian.uuid}
                                                    readOnly
                                                    style={{ fontSize: '0.85em' }}
                                                />
                                                <div className="input-group-append">
                                                    <button
                                                        className="btn btn-sm btn-outline-secondary"
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(respuestaDian.uuid);
                                                            alert('CUFE copiado al portapapeles');
                                                        }}
                                                        title="Copiar CUFE"
                                                    >
                                                        <i className="fas fa-copy"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <small className="text-muted d-block mb-2"><strong>Documentos DIAN:</strong></small>
                                            <div className="btn-group" role="group">
                                                {respuestaDian.pdf_url && (
                                                    <a
                                                        href={respuestaDian.pdf_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-danger"
                                                        download
                                                    >
                                                        <i className="fas fa-file-pdf mr-1"></i> Descargar PDF
                                                    </a>
                                                )}
                                                {respuestaDian.xml_url && (
                                                    <a
                                                        href={respuestaDian.xml_url}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-success"
                                                        download
                                                    >
                                                        <i className="fas fa-file-code mr-1"></i> Descargar XML
                                                    </a>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Vista Previa de la Factura */}
                        <div className="card card-info card-outline" id="vista-previa-factura-container">
                            <div className="card-header no-print" style={{ backgroundColor: '#f6fcfd', borderBottom: '2px solid #17a2b8' }}>
                                <h3 className="card-title" style={{ color: '#282828' }}>
                                    <i className="fas fa-file-invoice" style={{ color: '#17a2b8' }}></i> Vista Previa de la Factura
                                </h3>
                                <div className="card-tools">
                                    <button
                                        className="btn btn-sm btn-primary mr-1"
                                        onClick={imprimirPDFEditable}
                                        title="Imprimir factura en formato PDF"
                                    >
                                        <i className="fas fa-print mr-1"></i> Imprimir
                                    </button>
                                    <button
                                        className="btn btn-sm btn-danger mr-1"
                                        onClick={generarPDFEditable}
                                        title="Descargar factura en formato PDF"
                                    >
                                        <i className="fas fa-file-pdf mr-1"></i> PDF
                                    </button>
                                    <button
                                        className="btn btn-sm btn-success"
                                        onClick={abrirModalEmail}
                                        disabled={enviandoEmail}
                                        title="Enviar factura por correo electrónico"
                                    >
                                        {enviandoEmail ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                                Enviando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-envelope mr-1"></i> Email
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" id="vista-previa-factura-content">
                                <VistaPreviaFacturaPDF
                                    factura={factura}
                                    client={client}
                                    paciente={pacienteFactura}
                                    encabezadoPersonalizado={encabezadoPersonalizado}
                                    respuestaDian={respuestaDian}
                                    facturador={usuarios.find(u => u.id == factura?.users_id)}
                                />
                            </div>
                        </div>

                        {/* Listado de Recibos de Caja */}
                        <div className="card card-info card-outline no-print" id="recibos-caja-section">
                            <div className="card-header" style={{ backgroundColor: '#f6fcfd', borderBottom: '2px solid #17a2b8' }}>
                                <h3 className="card-title" style={{ color: '#282828' }}>
                                    <i className="fas fa-receipt" style={{ color: '#17a2b8' }}></i> Recibos de Caja
                                </h3>
                            </div>
                            <div className="card-body">
                                {recibosFactura.length > 0 ? (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>N° Recibo</th>
                                                    <th>Fecha Pago</th>
                                                    <th>Valor</th>
                                                    <th>Medio Pago</th>
                                                    <th>Estado</th>
                                                    <th>Observaciones</th>
                                                    <th>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {recibosFactura.map(recibo => (
                                                    <tr key={recibo.id}>
                                                        <td>{recibo.numero_recibo}</td>
                                                        <td>{new Date(recibo.fecha_pago).toLocaleDateString()}</td>
                                                        <td className="font-weight-bold">${Math.round(parseFloat(recibo.valor_pago)).toLocaleString('es-CO')}</td>
                                                        <td>{getMedioPagoTexto(recibo.forma_pago)}</td>
                                                        <td className="text-center">
                                                            <span className={`badge ${recibo.estado === 0 ? 'badge-outline-danger' : 'badge-outline-success'}`}>
                                                                {recibo.estado === 0 ? 'Anulado' : 'Activo'}
                                                            </span>
                                                        </td>
                                                        <td>{recibo.observaciones || '-'}</td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-info mr-1"
                                                                onClick={() => vistaPreviaRecibo(recibo)}
                                                                title="Vista Previa Recibo"
                                                            >
                                                                <i className="fas fa-eye"></i>
                                                            </button>
                                                            {recibo.estado !== 0 && (
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => anularRecibo(recibo.id)}
                                                                    title="Anular Recibo"
                                                                >
                                                                    <i className="fas fa-ban"></i>
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr style={{ backgroundColor: '#f6fcfd' }}>
                                                    <td colSpan="2" className="text-right font-weight-bold" style={{ color: '#282828' }}>Total Recibos Activos:</td>
                                                    <td className="font-weight-bold" style={{ color: '#28a745', fontSize: '1.1em' }}>
                                                        ${Math.round(recibosFactura.filter(r => r.estado !== 0).reduce((sum, r) => sum + parseFloat(r.valor_pago), 0)).toLocaleString('es-CO')}
                                                    </td>
                                                    <td colSpan="4"></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                ) : (
                                    <div className="text-center p-5">
                                        <i className="fas fa-inbox fa-3x mb-3" style={{ color: '#17a2b8', opacity: 0.5 }}></i>
                                        <p style={{ color: '#6c757d' }}>No se encontraron recibos de caja para esta factura.</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Asiento Contable - AL FINAL */}
                        <div className="card card-info card-outline no-print" id="asiento-contable-section">
                            <div className="card-header" style={{ backgroundColor: '#f6fcfd', borderBottom: '2px solid #17a2b8' }}>
                                <h3 className="card-title" style={{ color: '#282828' }}>
                                    <i className="fas fa-calculator" style={{ color: '#17a2b8' }}></i> Asiento Contable
                                </h3>
                                <div className="card-tools">
                                    <button
                                        className="btn btn-sm btn-outline-primary"
                                        onClick={imprimirAsientoContable}
                                        title="Imprimir Asiento Contable"
                                    >
                                        <i className="fas fa-print mr-1"></i> Imprimir
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="alert alert-info" style={{ backgroundColor: '#e3f2fd', borderColor: '#17a2b8', color: '#1976d2' }}>
                                    <i className="fas fa-info-circle mr-2"></i>
                                    Visualiza el movimiento contable completo: asiento de factura y asientos de recibos de caja que reducen el saldo.
                                </div>

                                {factura && (
                                    <div className="table-responsive">
                                        <table className="table table-bordered">
                                            <thead style={{ backgroundColor: '#f5f5f5' }}>
                                                <tr>
                                                    <th>Tercero</th>
                                                    <th>Código</th>
                                                    <th>Cuenta contable</th>
                                                    <th>Concepto</th>
                                                    <th className="text-right">Débito</th>
                                                    <th className="text-right">Crédito</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {generarAsientoContable().map((item, index) => (
                                                    <tr key={index} className={item.tipo === 'recibo' ? 'table-light' : ''}>
                                                        <td>{item.tercero}</td>
                                                        <td className="text-center font-weight-bold">{item.codigo}</td>
                                                        <td>{item.cuentaContable}</td>
                                                        <td style={{ fontSize: '0.85em' }}>{item.concepto}</td>
                                                        <td className="text-right font-weight-bold">
                                                            {item.debito > 0 ? `$${Math.round(item.debito).toLocaleString('es-CO')}` : ''}
                                                        </td>
                                                        <td className="text-right font-weight-bold">
                                                            {item.credito > 0 ? `$${Math.round(item.credito).toLocaleString('es-CO')}` : ''}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot style={{ backgroundColor: '#f0f8ff' }}>
                                                <tr className="font-weight-bold">
                                                    <td colSpan="4" className="text-right">TOTAL</td>
                                                    <td className="text-right" style={{ color: '#2e7d32' }}>
                                                        ${Math.round(generarAsientoContable().reduce((sum, item) => sum + item.debito, 0)).toLocaleString('es-CO')}
                                                    </td>
                                                    <td className="text-right" style={{ color: '#2e7d32' }}>
                                                        ${Math.round(generarAsientoContable().reduce((sum, item) => sum + item.credito, 0)).toLocaleString('es-CO')}
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                )}

                                <div className="mt-3">
                                    <small className="text-muted">
                                        <strong>Códigos de cuentas:</strong><br />
                                        • 1105: Caja (pagos en efectivo) |
                                        • 1110: Bancos (otros medios de pago) |
                                        • 1305: Cuentas por cobrar (ventas a crédito) |
                                        • 4165: Ingresos por servicios médicos<br />
                                        <strong>Nota:</strong> Las filas sombreadas corresponden a asientos de recibos de caja que reducen el saldo por cobrar.
                                    </small>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
            </div>

            {/* Modal Registrar Recibo de Caja */}
            {showModalRecibo && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => setShowModalRecibo(false)}>
                    <div className="modal-dialog modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header bg-info">
                                <h5 className="modal-title text-white">
                                    <i className="fas fa-money-bill-wave mr-2"></i>
                                    Registrar Recibo de Caja
                                </h5>
                                <button type="button" className="close text-white" onClick={() => setShowModalRecibo(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="alert alert-info mb-3">
                                    <i className="fas fa-info-circle mr-2"></i>
                                    <div className="d-inline-block">
                                        <strong>Factura N° {factura?.numero_factura}</strong>
                                        <span className="mx-2 text-muted">·</span>
                                        <span className="text-dark">Saldo pendiente (informativo): </span>
                                        <strong>${Math.round(parseFloat(factura?.valor_pendiente || factura?.valor_total || 0)).toLocaleString('es-CO')}</strong>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Valor del Recibo <span className="text-danger">*</span></label>
                                            <div className="input-group">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text" title="Pesos colombianos">
                                                        <i className="fas fa-dollar-sign" aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={valorRecibo}
                                                    onChange={(e) => setValorRecibo(e.target.value)}
                                                    placeholder="0"
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </div>
                                            <small className="text-muted">
                                                Máximo: ${Math.round(parseFloat(factura?.valor_pendiente || factura?.valor_total || 0)).toLocaleString('es-CO')}
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Medio de Pago <span className="text-danger">*</span></label>
                                            <select
                                                className="form-control"
                                                value={medioPago}
                                                onChange={(e) => setMedioPago(e.target.value)}
                                            >
                                                <option value="10">Efectivo</option>
                                                <option value="42">Consignación bancaria</option>
                                                <option value="1">Instrumento no definido</option>
                                                <option value="20">Cheque</option>
                                                <option value="30">Transferencia Crédito</option>
                                                <option value="31">Transferencia Débito</option>
                                                <option value="45">Transferencia Crédito Bancario</option>
                                                <option value="47">Transferencia Débito Bancaria</option>
                                                <option value="48">Tarjeta Crédito</option>
                                                <option value="49">Tarjeta Débito</option>
                                                <option value="ZZZ">Acuerdo mutuo</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Fecha de Pago <span className="text-danger">*</span></label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                value={fechaPago}
                                                onChange={(e) => setFechaPago(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label>Observaciones</label>
                                            <textarea
                                                className="form-control"
                                                rows="3"
                                                value={observacionesRecibo}
                                                onChange={(e) => setObservacionesRecibo(e.target.value)}
                                                placeholder="Observaciones adicionales (opcional)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalRecibo(false)}>
                                    <i className="fas fa-times mr-1"></i> Cancelar
                                </button>
                                <button type="button" className="btn btn-primary" onClick={guardarRecibo}>
                                    <i className="fas fa-save mr-1"></i> Guardar Recibo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Completar Información - Para Atender Paciente */}
            <Modal show={showModalCompletarInfo} onHide={handleCloseModalInfo}>
                <Modal.Header closeButton>
                    <Modal.Title>Aún no puedes atender citas</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Para atender una cita debes completar la siguiente información:</p>
                    <ul>
                        {!usuarioTieneFirma() ? <li>Firma</li> : <></>}
                        {!usuarioTieneRegistro() ? <li>Registro médico</li> : <></>}
                    </ul>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModalInfo}>Cancelar</Button>
                    <Button variant="primary" onClick={handleCompletarInfo}>Completar información</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Enviar Email */}
            <Modal
                show={showModalEmail}
                onHide={() => !enviandoEmail && setShowModalEmail(false)}
                centered
                dialogClassName="mx-email-dialog"
                contentClassName="mx-email-content"
            >
                <Modal.Header closeButton className="mx-email-head">
                    <Modal.Title>
                        <span className="mx-email-head-icon">
                            <i className="fas fa-paper-plane"></i>
                        </span>
                        Enviar Factura por Email
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="mx-email-body">
                    <div className="mx-email-info">
                        <i className="fas fa-info-circle"></i>
                        <div className="mx-email-info-text">
                            <span className="mx-email-info-title">
                                Factura N° {factura?.numero_factura || '—'}
                            </span>
                            <span className="mx-email-info-desc">
                                Se enviará un correo con el PDF adjunto al paciente.
                            </span>
                            {usuarios.find((u) => String(u.id) === String(factura?.users_id))?.name && (
                                <span className="mx-email-info-prof">
                                    Profesional: {usuarios.find((u) => String(u.id) === String(factura?.users_id))?.name}
                                </span>
                            )}
                        </div>
                    </div>

                    <label className="mx-email-label" htmlFor="emailDestinoFactura">
                        Correo Electrónico de Destino <span className="text-danger">*</span>
                    </label>
                    <div className="mx-email-input-wrap">
                        <input
                            id="emailDestinoFactura"
                            type="email"
                            className={`mx-email-input${emailDestino.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailDestino.trim()) ? ' is-invalid' : ''}`}
                            value={emailDestino}
                            onChange={(e) => setEmailDestino(e.target.value)}
                            placeholder="ejemplo@correo.com"
                            autoFocus
                            disabled={enviandoEmail}
                        />
                        <span className={`mx-email-input-icon${/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((emailDestino || '').trim()) ? ' is-valid' : ''}`}>
                            {/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((emailDestino || '').trim())
                                ? <i className="fas fa-check-circle"></i>
                                : <i className="fas fa-envelope"></i>}
                        </span>
                    </div>
                    <small className="mx-email-help">
                        Ingrese el correo electrónico donde desea enviar la factura
                    </small>
                </Modal.Body>

                <Modal.Footer className="mx-email-footer">
                    <Button
                        className="mx-email-btn-cancel"
                        onClick={() => setShowModalEmail(false)}
                        disabled={enviandoEmail}
                    >
                        <i className="fas fa-times mr-1"></i> Cancelar
                    </Button>
                    <Button
                        className="mx-email-btn-send"
                        onClick={enviarFacturaPorEmail}
                        disabled={enviandoEmail}
                    >
                        {enviandoEmail ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                                Enviando...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-paper-plane mr-1"></i> Enviar
                            </>
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Éxito Recibo */}
            {showModalExitoRecibo && reciboGuardado && (
                <Modal show={showModalExitoRecibo} onHide={() => setShowModalExitoRecibo(false)} centered>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            <i className="fas fa-check-circle"></i> Recibo Registrado Exitosamente
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="text-center mb-3">
                            <i className="fas fa-receipt fa-3x text-success mb-3"></i>
                            <h5>
                                Recibo N°{' '}
                                {reciboGuardado.numero_recibo
                                    || (reciboGuardado.recibo_id != null ? String(reciboGuardado.recibo_id) : '—')}
                            </h5>
                            <p className="text-muted mb-1">
                                Valor: <strong>${Math.round(parseFloat(reciboGuardado.valor_pago || reciboGuardado.valor_recibido || valorRecibo)).toLocaleString('es-CO')}</strong>
                            </p>
                            <p className="text-muted">
                                <small>Factura N° {factura?.numero_factura}</small>
                            </p>
                        </div>
                        <div className="alert alert-info">
                            <i className="fas fa-info-circle"></i> El recibo ha sido registrado correctamente en el sistema.
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowModalExitoRecibo(false)}>
                            Cerrar
                        </Button>
                        <Button 
                            variant="info" 
                            onClick={() => {
                                vistaPreviaRecibo(reciboGuardado);
                            }}
                        >
                            <i className="fas fa-file-pdf"></i> Ver PDF
                        </Button>
                        <Button 
                            variant="primary" 
                            onClick={() => {
                                vistaPreviaRecibo(reciboGuardado);
                                setShowModalExitoRecibo(false);
                            }}
                        >
                            <i className="fas fa-print"></i> Imprimir
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default InformacionFactura;
